import { useEffect, useState } from 'react';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export function inspectPhone(value) {
  const raw = String(value || '').trim();
  const fail = { valid: false, digits: '', e164: '', formatted: '', country: '' };
  if (!raw || !/^[+\d\s().-]+$/.test(raw)) return fail;
  let text = raw;
  const digits = raw.replace(/\D/g, '');
  if (raw.startsWith('00')) text = `+${raw.slice(2)}`;
  else if (!raw.startsWith('+') && digits.length > 11 && digits.length <= 15) text = `+${digits}`;
  const phone = parsePhoneNumberFromString(text, { defaultCountry: 'BR', extract: false });
  if (!phone || phone.ext || !phone.country || !phone.isValid()) {
    // FONE_SIMPLES_0311 (GROK2): aceita qualquer número (8 a 15 dígitos); sem + vira +55 (Brasil) em silêncio.
    if (/^[+\d\s().-]+$/.test(raw) && digits.length >= 8 && digits.length <= 15) {
      const d = raw.startsWith('+') || raw.startsWith('00') || digits.length > 11 ? digits.replace(/^00/, '') : `55${digits}`;
      return { valid: true, digits: d, e164: `+${d}`, formatted: `+${d}`, country: phone?.country || (d.startsWith('55') ? 'BR' : ''), national: d.startsWith('55') ? d.slice(2) : d };
    }
    return { ...fail, country: phone?.country || '' };
  }
  return { valid: true, digits: phone.number.slice(1), e164: phone.number,
    formatted: phone.formatInternational(), country: phone.country, national: phone.nationalNumber };
}

export function useConfirmedPhone(value, { original = '', editing = false, resetKey } = {}) {
  const [confirmation, setConfirmation] = useState('');
  useEffect(() => setConfirmation(''), [value, resetKey]);
  const phone = inspectPhone(value);
  const previous = inspectPhone(original);
  const unchanged = editing && (String(value || '') === String(original || '')
    || (phone.valid && previous.valid && phone.e164 === previous.e164));
  const confirmed = unchanged || phone.valid || confirmation === String(value); // FONE_SIMPLES_0311: sem caixinha de confirmação
  const error = !phone.valid ? 'Informe o código do país, DDD e número completo válido.'
    : 'Confirme o país, o DDD e o número completo antes de continuar.';
  return { ...phone, unchanged, confirmed, ready: unchanged || (phone.valid && confirmed),
    error, digits: unchanged ? String(value || '').replace(/\D/g, '') : phone.digits,
    confirm: (checked) => setConfirmation(checked ? String(value) : '') };
}
